/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Image_Prefix_PlaceholderInputs */



/**
* | output |
* | --- |
* | "DVD" |
*
* @param {Image_Export_Image_Prefix_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_image_prefix_placeholder = /** @type {((inputs?: Image_Export_Image_Prefix_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Image_Prefix_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DVD")
	if (locale === "de") return /** @type {LocalizedString} */ ("DVD")
	if (locale === "it") return /** @type {LocalizedString} */ ("DVD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("DVD")
	if (locale === "es") return /** @type {LocalizedString} */ ("DVD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("DVD")
	if (locale === "ja") return /** @type {LocalizedString} */ ("DVD")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डीवीडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DVD")
	return /** @type {LocalizedString} */ ("DVD")
});